module.exports = __webpack_public_path__ + "img/ic_vibe.8199ed09.png";